import request from "tools/request"

export const getTasks = (applicationUuid, statusCsv) => async () => {
    const params = statusCsv ? { status: statusCsv } : undefined
    const res = await request(`applications/${applicationUuid}/tasks`, 'GET', null, false, {}, params)
    return res
}

export const getTaskCounts = (applicationUuid) => async () => {
    const res = await request(`applications/${applicationUuid}/tasks/counts`, 'GET')
    return res
}

export const getDirectorySuggestions = (applicationUuid, q) => async () => {
    const res = await request(`applications/${applicationUuid}/tasks/directory-suggestions`, 'GET', null, false, {}, { q })
    return res
}

export const createTask = (applicationUuid, payload) => async () => {
    const res = await request(`applications/${applicationUuid}/tasks`, 'POST', payload)
    return res
}

export const getTask = (taskId) => async () => {
    const res = await request(`tasks/${taskId}`, 'GET')
    return res
}

export const reassignTask = (taskId, payload) => async () => {
    const res = await request(`tasks/${taskId}/reassign`, 'POST', payload)
    return res
}

export const rejectTask = (taskId, payload) => async () => {
    const res = await request(`tasks/${taskId}/reject`, 'POST', payload)
    return res
}

export const completeTask = (taskId, payload) => async () => {
    const res = await request(`tasks/${taskId}/complete`, 'POST', payload)
    return res
}


export const getNotifications = (params = {}) => async () => {
    // Acceptable shape: { cursor, limit, unread, application_id }
    // silentOnError=true because this runs on a 30s background poll and errors
    // (e.g. backend restart) should not spam the user with toasts.
    const res = await request('notifications', 'GET', null, false, {}, params, true, true)
    return res
}

export const getUnreadNotificationCount = () => async () => {
    // Silent for the same reason as getNotifications — background polling.
    const res = await request('notifications/unread-count', 'GET', null, false, {}, undefined, true, true)
    return res
}

export const markNotificationRead = (notificationId) => async () => {
    const res = await request(`notifications/${notificationId}/read`, 'POST', null, false, {}, undefined, true, true)
    return res
}

export const markAllNotificationsRead = () => async () => {
    const res = await request('notifications/read-all', 'POST', null, false, {}, undefined, true, true)
    return res
}
